import { useTypedSelector } from "../redux";
import { Configuration } from "../clients/FirebaseClient/types";

export const useCurrentConfiguration = (): Configuration => {
    const configurations = useTypedSelector(state => state.configuration);
    if (!configurations.currentConfigurationId) {
        throw new Error("no current configuration selected. Use 'load' first");
    }
    return configurations.configurations[configurations.currentConfigurationId];
};
